import { NgModule } from "@angular/core";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ResponsePanelComponent } from "./components/response-panel/response-panel.component";
import { SystemadministrationComponent } from "./systemadministration.component";
import { SystemadministrationService } from "./systemadministration.service";
import { SysadmArbetsorderComponent } from "./tabs/sysadm-arbetsorder/sysadm-arbetsorder.component";
import { SysadmAvverkningsanmalanComponent } from "./tabs/sysadm-avverkningsanmalan/sysadm-avverkningsanmalan.component";
import { SysadmChecklistaComponent } from "./tabs/sysadm-checklista/sysadm-checklista.component";
import { SysadmEudrComponent } from "./tabs/sysadm-eudr/sysadm-eudr.component";
import { SysadmFeaturetoggleComponent } from "./tabs/sysadm-featuretoggle/sysadm-featuretoggle.component";
import { SysadmGeometriComponent } from "./tabs/sysadm-geometri/sysadm-geometri.component";
import { SysadmKundorderComponent } from "./tabs/sysadm-kundorder/sysadm-kundorder.component";
import { SysadmMiscComponent } from "./tabs/sysadm-misc/sysadm-misc.component";
import { SysadmPrologComponent } from "./tabs/sysadm-prolog/sysadm-prolog.component";
import { SysadmVacsComponent } from "./tabs/sysadm-vacs/sysadm-vacs.component";
import { SysadmVerksamhetsomradenComponent } from "./tabs/sysadm-verksamhetsomraden/sysadm-verksamhetsomraden.component";
import { InmatningtestComponent } from "./tabs/sysadm-viol3/inmatningtest/inmatningtest.component";
import { LeveranserComponent } from "./tabs/sysadm-viol3/leveranser/leveranser.component";
import { IntegrationService } from "./tabs/sysadm-viol3/service/integration.service";
import { SysadmViol3Component } from "./tabs/sysadm-viol3/sysadm-viol3.component";
import { Viol3xmlComponent } from "./tabs/sysadm-viol3/viol3xml/viol3xml.component";
import { VirkesorderHistorikComponent } from "./tabs/sysadm-viol3/virkesorder-historik/virkesorder-historik.component";
import { VirkesorderViol3PreviewComponent } from "./tabs/sysadm-viol3/virkesorder-viol3-preview/virkesorder-viol3-preview.component";
import { SysadmMoveAvtalComponent } from "./tabs/sysadm-virkeskop/sysadm-move-avtal/sysadm-move-avtal.component";
import { SysadmVirkeskopComponent } from "./tabs/sysadm-virkeskop/sysadm-virkeskop.component";
import { SysadmVirkesleverantorerComponent } from "./tabs/sysadm-virkesleverantorer/sysadm-virkesleverantorer.component";
import { SysadmWebinstallningarComponent } from "./tabs/sysadm-webinstallningar/sysadm-webinstallningar.component";

@NgModule({
    providers: [
        SystemadministrationService,
        IntegrationService
    ],
    imports: [
        RaskCommonModule,
        MapModule,
        SysadmMoveAvtalComponent,
        SysadmChecklistaComponent,
        SystemadministrationComponent,
        SysadmFeaturetoggleComponent,
        SysadmVacsComponent,
        SysadmPrologComponent,
        SysadmKundorderComponent,
        SysadmArbetsorderComponent,
        SysadmMiscComponent,
        SysadmAvverkningsanmalanComponent,
        ResponsePanelComponent,
        SysadmVirkeskopComponent,
        SysadmViol3Component,
        VirkesorderViol3PreviewComponent,
        Viol3xmlComponent,
        VirkesorderHistorikComponent,
        LeveranserComponent,
        SysadmGeometriComponent,
        SysadmVirkesleverantorerComponent,
        SysadmVerksamhetsomradenComponent,
        SysadmWebinstallningarComponent,
        InmatningtestComponent,
        SysadmEudrComponent
    ]
})
export class SystemadministrationModule { }
